import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { getSpecList, isEmpty, isEmptyArray, isNotEmpty, isNotEmptyArray } from '../../common/util.services';
import { getQualityParameter, saveQualityParam } from '../order.services';
import IButton from '../../../components/button/i-button.component';
import { Grid } from '@mui/material';

const QualityParamsComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [qltyParams, setQltyParams] = useState(rows);
  const [isQltySet, setIsQltySet] = useState(false);
  const [qltyModel] = useState({orderId: null, costingId: null, linkId: null, specs: null});
  const [message, setMessage] = useState('');
  const columns: GridColDef[] = [
    { field: 'parameter', headerName: 'Parameter', filterable: false, sortable: false, width: 190, editable: true },
    { field: 'expectedVal', headerName: 'Expected Value', filterable: false, sortable: false, width: 190, editable: true },
  ];

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      qltyModel.orderId = props.orderId;
      qltyModel.costingId = props.costingId;
      qltyModel.linkId = props.linkId;
      let specList = getSpecList(props.specData);
      let specs: any = [];
      specList.map((spec: any) => {
        let value = props.specData[spec.fieldObject];
        let parameter = spec.fieldName;
        specs.push([parameter, value]);
      });

      qltyModel.specs = specs;

      getQualityParameter(qltyModel, appContext,
        (response: any) => {
          setQltyParams(response.data);
          setIsQltySet(!isEmpty(response.data[0].rowId));
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, []);

  const updateSerialNumber = (rows: any) => {
    if (isNotEmptyArray(rows)) {
      rows.forEach((element: any, index: number) => {
        element.id = index + 1;
      });
    }
    
    return rows;
  }

  const addRow = (params: any) => {
    const rows = [...qltyParams];
    let row = {id: qltyParams.length + 1, parameter: '', expectedVal: ''};
    rows.splice(qltyParams.length, 0, row);
    setQltyParams(rows);
  }

  const deleteRow = (row: any) => {
    const rows = qltyParams.filter((r: any) => !(r.id === row.id));
    let updateRows = updateSerialNumber(rows);
    setQltyParams(updateRows);
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    const rows = [...qltyParams];
    rows[updatedRow.id - 1] = updatedRow;
    setQltyParams(rows);
  }

  const onSubmit = () => {
    let valid = true;
    let message = '';
    let count = 0;

    for(let i = 0; i < qltyParams.length; ++i) {
      let element = qltyParams[i];

      if(!isEmpty(element.parameter.trim()) && !isEmpty(element.expectedVal.trim())) {
        ++count;
      }

      if((isEmpty(element.parameter) && !isEmpty(element.expectedVal)) || (!isEmpty(element.parameter) && isEmpty(element.expectedVal))) {
        valid = false;
        message = 'Specify parameter and expected value.';
        break;
      }

      element.orderId = props.orderId;
      element.costingId = props.costingId;
      element.linkId = props.linkId;
      element.inputCode = props.inputCode;
    };

    if(valid && count <= 0) {
      valid = false;
      message = "Specify at least one quality paramater";
    }

    if(props.challanCount > 0) {
      valid = false;
      message = "Challan exists. Delete the challan first.";
    }

    setMessage(message);

    if(valid) {
      saveQualityParam(qltyParams, appContext,
        (response: any) => {
          setIsQltySet(true);
          appContext.setShowLoader(false);
          setLoading(false);
          props.onOk();
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }

  const onCancel = () => {
    props.onCancel(isQltySet);
  }

  return (
    <div>
      <Grid container spacing={0} maxWidth={450}>
        <IGridComponent title='' rows={qltyParams} columns={columns} maxHeight={"60vh"} loading={loading} 
          showAddBtn={true} addBtnText='Add' getRowId={(row: any) => row.id} hideFooterPagination={true} hideFooter={false} 
          maxWidth={450} addRow={addRow} processRowUpdate={processRowUpdate} handleDeleteAction={deleteRow}
          showDeleteAction={false} showAction={false} showEditAction={false} showApproveAction={false} 
          extraText={message} showExtraText={isNotEmpty(message)}/>
      </Grid>
      <div className='btn-panel'>
        <IButton name='submit' label='Submit' color="primary" onActionEvent={onSubmit}/>
        <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
      </div>
    </div>
  );
}

export default QualityParamsComponent;